import React from 'react';
import PropTypes from 'prop-types';

const Select = ({
  noneOption,
  options,
  selected,
  onChange,
  ...props
}) => (
  <select
    {...props}
    value={selected ? selected : noneOption}
    onChange={(evt) => { onChange(evt.target.value); }}
  >
    {
      noneOption ? (<option value={''}>{noneOption}</option>) : null
    }
    {
      options ?
        options.map((o, i) =>
          (typeof(o) === 'object') ?
            <option key={i} value={o.value}>{o.text}</option> :
            <option key={i} value={o}>{o}</option>) :
        null
    }
  </select>
);

Select.propTypes = {
  noneOption: PropTypes.string,
  options: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(PropTypes.object)
  ]),
  selected: PropTypes.node,
  onChange: PropTypes.func.isRequired
};

export default Select;


// WEBPACK FOOTER //
// src/Components/SelectComponent.jsx